import { helper } from '@ember/component/helper';

import PassPropertiesModifier from 'rise-ui/modifiers/pass-properties.js';

export default helper(function passPropertiesHelper([ object ]) {
  return class extends PassPropertiesModifier {
    object = object;
  };
});
